import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AboutComponent } from './about.component';
import { VersionInfoComponent } from './version-info/version-info.component';
import {VersionService} from '../../../services/version.service';



@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [
        AboutComponent,
        VersionInfoComponent
    ],
    exports: [
        AboutComponent,
        VersionInfoComponent
    ],
    providers: [
        VersionService,
    ]
})
export class AboutModule { }
